import React, { useState, useEffect, useMemo } from 'react';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Spinner,
    Alert,
    Row,
    Col,
    FormFeedback
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createUser } from './redux/dispatcher';
import { fetchCompanyList } from 'components/companyList/redux/dispatcher';
import { fetchRegionList } from 'components/regionList/redux/dispatcher';
import toast from 'react-hot-toast';

function AddUser({ args }) {
    const dispatch = useDispatch();
    const userList = useSelector((state) => state.userListReducer);
    const [loginUserType] = useState(useSelector((state) => state.authReducer).data?.user?.role)
    const companyListData = useSelector((state) => state.companyListReducer?.data?.data) || [];
    const rawRegionData = useSelector((state) => state.regionListReducer?.data);
    const regionListData = useMemo(() => {
        if (Array.isArray(rawRegionData)) return rawRegionData;
        if (Array.isArray(rawRegionData?.data)) return rawRegionData.data;
        if (Array.isArray(rawRegionData?.payload?.data)) return rawRegionData.payload.data;
        return [];
    }, [rawRegionData]);

    const [modal, setModal] = useState(false);
    const [status, setStatus] = useState(true);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [mobile, setMobile] = useState('');
    const [loading, setLoading] = useState(userList?.isLoading);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
    const [roleType, setRoleType] = useState('')
    const [confrimPassword, setConfrimPassword] = useState('')
    const [selectedCompanies, setSelectedCompanies] = useState([])
    const [companySearch, setCompanySearch] = useState('')
    const [selectedRegion, setSelectedRegion] = useState('')
    // const [isLoader, setIsLoader] = useState(true);
    const [formError, setFormError] = useState({
        firstName: false,
        lastName: false,
        email: false,
        mobile: false,
        password: false,
        confirmpassword: false,
        roleType: false,
        region_id: false,
        company_ids: false,
    })

    const isZoneAdmin = roleType === 'zone_admin' || roleType === 'regional_admin';

    useEffect(() => {
        if (modal && (roleType === 'fluid_handler' || isZoneAdmin)) {
            dispatch(fetchCompanyList());
        }
        if (modal && isZoneAdmin) {
            dispatch(fetchRegionList());
        }
    }, [dispatch, modal, roleType, isZoneAdmin]);

    const filteredCompanyList = companyListData.filter(company =>
        company?.company_name?.toLowerCase().includes(companySearch.toLowerCase())
    );

    const isAllCompaniesSelected = filteredCompanyList.length > 0 &&
        filteredCompanyList.every(company => selectedCompanies.includes(company?.id));

    const toggleCompany = (companyId) => {
        if (companyId === null || companyId === undefined) return;

        setSelectedCompanies(prev => {
            const next = prev.includes(companyId)
                ? prev.filter(id => id !== companyId)
                : [...prev, companyId];
            if (next.length > 0) {
                setFormError(prevState => ({ ...prevState, company_ids: false }));
            }
            return next;
        });
    };

    const toggleSelectAllCompanies = () => {
        if (isAllCompaniesSelected) {
            const filteredIds = filteredCompanyList.map(c => c?.id).filter(id => id !== null && id !== undefined);
            setSelectedCompanies(prev => prev.filter(id => !filteredIds.includes(id)));
        } else {
            const filteredIds = filteredCompanyList.map(c => c?.id).filter(id => id !== null && id !== undefined);
            setSelectedCompanies(prev => {
                const newIds = filteredIds.filter(id => !prev.includes(id));
                return [...prev, ...newIds];
            });
            setFormError(prevState => ({ ...prevState, company_ids: false }));
        }
    };


    const toggleModal = () => {
        setModal(!modal);
        setError('');
        setLoading(false);
        setFirstName('');
        setLastName('')
        setEmail('')
        setMobile('')
        setRoleType('')
        setPassword('')
        setConfrimPassword('')
        setSelectedCompanies([])
        setCompanySearch('')
        setSelectedRegion('')
        setErrorMessage('')
        setFormError({
            firstName: false,
            lastName: false,
            email: false,
            mobile: false,
            password: false,
            confirmpassword: false,
            roleType: false,
            region_id: false,
            company_ids: false,
        })
    };

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const toggleCinfirmPasswordVisibility = () => {
        setIsConfirmPasswordVisible(!isConfirmPasswordVisible)
    }

    const handleStatusChange = () => setStatus(!status);


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const isCompanyRequired = isZoneAdmin;
        const validCompanyIds = selectedCompanies.filter(id => id !== null && id !== undefined);
        const isCompanyInvalid = isCompanyRequired && validCompanyIds.length === 0;

        // Check if required fields are empty
        if (!firstName || !lastName || !email || !password || !confrimPassword || !roleType || (isZoneAdmin && !selectedRegion) || isCompanyInvalid || (mobile.length > 0 && mobile.length < 10)) {
            setFormError({
                firstName: formError.firstName || !firstName,
                lastName: formError.lastName || !lastName,
                email: formError.email || !email,
                password: formError.password || !password,
                confirmpassword: formError.confirmpassword || !confrimPassword,
                mobile: formError.mobile,
                roleType: !roleType ? true : false,
                region_id: isZoneAdmin ? !selectedRegion : false,
                company_ids: isCompanyInvalid,
            });
            setErrorMessage('Please correct the errors in the form.');
            setLoading(false);
            return;
        }

        // Check if passwords match
        if (password !== confrimPassword) {
            toast.error('Passwords do not match')
            setErrorMessage('Passwords do not match.');
            setLoading(false);
            return;
        }

        // Reset error messages
        setErrorMessage('');
        setError('');
        try {
            const userData = {
                first_name: firstName,
                last_name: lastName,
                email_id: email,
                password: password,
                role: roleType,
                status: status ? 'active' : 'inactive',
                ...(mobile && { mobile_number: mobile }),
                ...((roleType === 'fluid_handler' || isZoneAdmin) && validCompanyIds.length > 0 && { company_ids: validCompanyIds }),
                ...(isZoneAdmin && selectedRegion && { region_id: selectedRegion })
            };

            // Now you can send userData

            dispatch(createUser(userData, toggleModal))
        } catch (err) {
            setErrorMessage('Error adding user. Please try again.')
            // setError('Error adding user. Please try again.');
        } finally {
            setLoading(false);
        }
    };


    //Regex for validation 
    const validateFirstName = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, firstName: false }));
            return;
        }
        const regex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]{2,25}$/;


        const isValid = regex.test(value);
        setFormError(prevState => ({ ...prevState, firstName: !isValid }));
    };

    const validateLastName = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, lastName: false }));
            return;
        }
        const regex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]{2,25}$/;
        const isValid = regex.test(value);
        setFormError(prevState => ({ ...prevState, lastName: !isValid }));
    };

    const validateEmail = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, email: false }));
            return;
        }
        const regex = /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/;
        const isValid = regex.test(value);
        setFormError(prevState => ({ ...prevState, email: !isValid }));
    };

    const validateMobile = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, mobile: false }));
            return;
        }
        const regex = /^[0-9]{10}$/;
        const isValid = regex.test(value);
        setFormError(prevState => ({ ...prevState, mobile: !isValid }));
    };

    const validatePassword = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, password: false }));
            return;
        }
        const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/;
        const isValid = regex.test(value);
        setFormError(prevState => ({ ...prevState, password: !isValid }));
    };

    const validateConfirmPassword = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, confirmpassword: false }));
            return;
        }
        const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/;
        const isValid = regex.test(value);

        setFormError(prevState => ({ ...prevState, confirmpassword: !isValid }));
    };

    // if(isLoader){
    //     return <Loader />
    // }

    return (
        <div>
            <Button className="btn-primary" onClick={toggleModal}>Add User
            </Button>

            <Modal isOpen={modal} toggle={toggleModal} {...args} modalClassName="custom-modal">
                <h1 style={{ textAlign: 'center', borderBottom: '4px solid rgb(14, 61, 13)', color: 'rgb(14, 61, 13)' }} className="  m-3">
                    Add User
                </h1>
                <ModalBody>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="firstName">First Name<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="firstName"
                                        name="firstName"
                                        placeholder="Enter First Name"
                                        type="text"
                                        value={firstName}
                                        invalid={formError.firstName}
                                        onChange={(e) => {
                                            setFirstName(e.target.value)
                                            validateFirstName(e)
                                        }}
                                        maxLength={25}
                                    />
                                    <FormFeedback>First Name must only contain alphabets.</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="lastName">Last Name<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="lastName"
                                        name="lastName"
                                        placeholder="Enter Last Name"
                                        type="text"
                                        value={lastName}
                                        invalid={formError.lastName}
                                        onChange={(e) => {
                                            setLastName(e.target.value)
                                            validateLastName(e)
                                        }}
                                        maxLength={25}
                                    />
                                    <FormFeedback>Last Name must only contain alphabets.</FormFeedback>
                                </FormGroup>

                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="email">Email<span style={{ color: 'red' }}>*</span> (User ID)</Label>
                                    <Input
                                        id="email"
                                        name="email"
                                        placeholder="Enter Email Id"
                                        type="email"
                                        value={email}
                                        invalid={formError.email}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            setEmail(e.target.value)
                                            validateEmail(e)
                                        }}
                                    />
                                    <FormFeedback>Email must be a valid email address.</FormFeedback>
                                </FormGroup>

                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="mobile">Mobile</Label>
                                    <Input
                                        id="mobile"
                                        name="mobile"
                                        placeholder="Enter Mobile"
                                        type="text"
                                        value={mobile}
                                        invalid={formError.mobile}
                                        onChange={(e) => {
                                            setMobile(e.target.value)
                                            validateMobile(e)
                                        }}
                                        maxLength={10}
                                    />
                                    <FormFeedback>Mobile Number must be exactly 10 digits and contain only numbers.</FormFeedback>

                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={isZoneAdmin ? 6 : 12}>
                                <FormGroup>
                                    <Label for="roletype">Select Role<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        type="select"
                                        name="selectRole"
                                        id="roletype"
                                        value={roleType}
                                        onChange={(e) => {
                                            setRoleType(e.target.value)
                                            setSelectedCompanies([])
                                            setCompanySearch('')
                                            setSelectedRegion('')
                                            setFormError(prevState => ({ ...prevState, roleType: false, company_ids: false, region_id: false }));
                                        }}
                                        invalid={formError.roleType}
                                    >
                                        <option value="">Select Role</option>

                                        {loginUserType === 'super_admin' && (
                                            <>
                                                <option value="enterprise_admin">Enterprise Admin</option>
                                                <option value="regional_admin">Regional Admin</option>
                                                <option value="company_admin">Company Admin</option>
                                                <option value="fluid_handler">Fluid Handler</option>
                                            </>
                                        )}
                                        {loginUserType === 'enterprise_admin' && (
                                            <>
                                                <option value="regional_admin">Regional Admin</option>
                                                <option value="company_admin">Company Admin</option>
                                                <option value="fluid_handler">Fluid Handler</option>
                                            </>
                                        )}
                                        {(loginUserType === 'zone_admin' || loginUserType === 'regional_admin') && (
                                            <>
                                                <option value="company_admin">Company Admin</option>
                                                <option value="fluid_handler">Fluid Handler</option>
                                            </>
                                        )}
                                        {loginUserType === 'company_admin' && (
                                            <>
                                                <option value="fluid_handler">Fluid Handler</option>
                                            </>
                                        )}
                                    </Input>
                                    <FormFeedback>Please select role type.</FormFeedback>
                                </FormGroup>
                            </Col>
                            {isZoneAdmin && (
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="regionSelect">Select Region<span style={{ color: 'red' }}>*</span></Label>
                                        <Input
                                            type="select"
                                            name="selectRegion"
                                            id="regionSelect"
                                            value={selectedRegion}
                                            onChange={(e) => {
                                                setSelectedRegion(e.target.value)
                                                setFormError(prevState => ({ ...prevState, region_id: false }));
                                            }}
                                            invalid={formError.region_id}
                                        >
                                            <option value="">Select Region</option>
                                            {regionListData.map((region) => (
                                                <option key={region?.id} value={region?.id}>
                                                    {region?.name}
                                                </option>
                                            ))}
                                        </Input>
                                        <FormFeedback>Please select a region.</FormFeedback>
                                    </FormGroup>
                                </Col>
                            )}
                        </Row>

                        {(roleType === 'fluid_handler' || isZoneAdmin) && (
                            <Row>
                                <Col md={12}>
                                    <FormGroup className="mb-2">
                                        <Label className="mb-1">
                                            {isZoneAdmin ? (
                                                <>Select Company<span style={{ color: 'red' }}>*</span></>
                                            ) : (
                                                'Companies (Optional)'
                                            )}
                                        </Label>
                                        <div style={{ border: formError.company_ids ? '1px solid #dc3545' : '1px solid #ced4da', borderRadius: 4, padding: 6, background: '#fff', maxHeight: 300, overflowY: 'auto' }}>
                                            <div className="mb-2">
                                                <Input
                                                    placeholder="Search Company"
                                                    value={companySearch}
                                                    onChange={e => setCompanySearch(e.target.value)}
                                                    style={{ padding: '4px 8px', fontSize: '14px' }}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <div className="custom-control custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="selectAllCompaniesAdd"
                                                        checked={isAllCompaniesSelected}
                                                        onChange={toggleSelectAllCompanies}
                                                    />
                                                    <label
                                                        className="custom-control-label"
                                                        htmlFor="selectAllCompaniesAdd"
                                                        style={{ fontSize: '14px', cursor: 'pointer', textDecoration: 'underline' }}
                                                    >
                                                        {isAllCompaniesSelected ? 'Clear All' : 'Select All'}
                                                    </label>
                                                </div>
                                            </div>
                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px' }}>
                                                {filteredCompanyList.map(company => {
                                                    const id = company?.id;
                                                    return (
                                                        <div key={id} className="custom-control custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id={`company-add-${id}`}
                                                                value={id}
                                                                checked={selectedCompanies.includes(id)}
                                                                onChange={() => toggleCompany(id)}
                                                            />
                                                            <label
                                                                className="custom-control-label"
                                                                htmlFor={`company-add-${id}`}
                                                                style={{ fontSize: '14px' }}
                                                            >
                                                                {company?.company_name}
                                                            </label>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            {filteredCompanyList.length === 0 && (
                                                <div className="text-muted small">No companies found</div>
                                            )}
                                        </div>
                                        {formError.company_ids && (
                                            <div className="text-danger small mt-1">Please select at least one company.</div>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}

                        {/* <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label>Select Company*</Label>
                                    <Input
                                        type="text"
                                        id="searchInput"
                                        value={searchData}
                                        onChange={handleCompanySearch}
                                        placeholder="Search machine by thier name..."
                                    />
                                    <div style={{ maxHeight: '125px', overflowY: 'auto', border: '1px solid #ced4da', padding: '10px' }} className='rounded '>

                                        {filteredCompanyList.map((item, id) => (
                                            <CustomInput
                                                key={id}
                                                type="checkbox"
                                                id={`machine-${id}`}
                                                label={item}
                                                value={item}
                                                checked={selectedCompany.includes(item)}
                                                onChange={handleCompanySelection}
                                                className='m-1'
                                            />
                                        ))}
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row> */}

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="password">Password<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="password"
                                        name="password"
                                        placeholder="Enter Password"
                                        type={isPasswordVisible ? "text" : "password"}
                                        value={password}
                                        invalid={formError.password}
                                        onChange={(e) => {
                                            setPassword(e.target.value)
                                            validatePassword(e)
                                        }}
                                    />
                                    <FormFeedback>Password must be at least 8 characters long, contain at least one number and one special character.</FormFeedback>
                                    <i
                                        className={`fa fa-eye${isPasswordVisible ? '' : '-slash'} mr-3 mt-1`}
                                        style={{
                                            position: 'absolute',
                                            right: 10,
                                            top: formError.password ? '35%' : '52%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer'
                                        }}
                                        onClick={togglePasswordVisibility}
                                    />

                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="confrimpassword">Confirm Password<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        id="confrimpassword"
                                        name="confrimpassword"
                                        placeholder="Enter Confirm Password"
                                        type={isConfirmPasswordVisible ? "text" : "password"}
                                        value={confrimPassword}
                                        // invalid={formError.confirmpassword}
                                        onChange={(e) => {
                                            setConfrimPassword(e.target.value)
                                            validateConfirmPassword(e)
                                        }}
                                    />
                                    {/* <FormFeedback>Confirm Password must be at least 8 characters long, contain at least one number and one special character.</FormFeedback> */}
                                    <i
                                        className={`fa fa-eye${isConfirmPasswordVisible ? '' : '-slash'} mr-3 mt-1`}
                                        style={{
                                            position: 'absolute',
                                            right: 10,
                                            top: formError.password ? '35%' : '52%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer'
                                        }}
                                        onClick={toggleCinfirmPasswordVisibility}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <Label for="statusSelect">Status</Label>
                            <CustomInput
                                type="switch"
                                id="statusSelect"
                                name="status"
                                label={status ? 'Active' : 'Inactive'}
                                checked={status}
                                onChange={handleStatusChange}
                            />
                        </FormGroup>

                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button className="btn-primary" onClick={handleFormSubmit} disabled={loading}>
                        {loading ? <Spinner size="sm" className='mr-5 ml-5' /> : 'Add User'}
                    </Button>

                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default AddUser;
